module.exports = __webpack_public_path__ + "img/icon-vtexio.af219bb0.svg";